module.exports = __webpack_public_path__ + "img/photo-07.4a66ee73.jpg";